<template>
    <div>
        <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>

        <Card :bordered="false" :style="{marginBottom:'10px'}">
            <!--表格数据-->
          <Card v-for="(item, index) in data" v-if="item.configKey !== 'openIds' && item.configKey !== 'activity'">
            <p slot="title">{{item.remark}}</p>
            <div class="hs-screen-row">
                <Input v-model="item.configValue" :disabled="data[index].disable" placeholder="名称" style="width: 200px"/>
            </div>
            <div class="hs-screen-row">
                <Button type="primary" @click="updateDisable(index, item)" v-if="data[index].disable">修改</Button>
                <Button type="primary" @click="update(index, item)" v-if="!data[index].disable">确定修改</Button>
            </div>
            <div class="hs-screen-row">
              <Button @click="cancle(index, item)" v-if="!data[index].disable">取消</Button>
            </div>
          </Card>
        </Card>
    </div>
</template>

<script>
    import hsBreadcrumb from '@/components/hs-breadcrumb';
    export default {
        name: "config",
        data() {
            return {
                total: 0,
                isTableLoading: false,
                dateInit: '',
                params: {
                    configId: '',
                    configValue: ''
                },
                // 表格列
                // 表格数据
                data: [],
                // 面包屑
                breadcrumb: [
                    {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
                    {name: '系统管理', url: '', icon: '', size: 0},
                    {name: '平台配置', url: '', icon: '', size: 0}
                ],
              disable: true
            }
        },
        created() {
            // 平台配置-列表查询
            this.findAllConfig();
        },
        methods: {
            // 平台配置-列表查询
            findAllConfig() {
                this.isTableLoading = true;
                this.axios.post('/tenantConfig/findAllConfig', this.params).then(res => {
                    this.isTableLoading = false;
                    if (res.status == 200) {
                        this.data = res.data;
                        this.data.forEach(item => {
                          item.disable = true
                        })
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '配置列表查询接口报错',
                            duration: 0
                        });
                    }
                })
            },
          updateDisable(index, item) {
            item.disable = false
            this.$set(this.data, index, item)
          },
          cancle(index, item) {
            item.disable = true
            this.$set(this.data, index, item)
          },
            // 显示操作模态框
          update(index, item) {
              this.params.configKey = item.configKey
              this.params.configValue = item.configValue
              this.axios.post('/tenantConfig/updateConfigByKey', this.params).then(res => {
                console.log(res);
                item.disable = true
                this.$set(this.data, index, item)
                setTimeout(()=>{
                  this.$Spin.hide();
                },300);
                if (res.status == 200) {
                  this.$Message.success('操作成功.');
                }
                if(res.status == 201){
                  this.$Message.error(res.msg);
                }
                if (res.status == 500) {
                  this.$Notice.error({
                    title: '服务器内部错误',
                    desc: '编辑配置接口报错',
                    duration: 0
                  });
                }
              })
            },
        },
        components: {
            hsBreadcrumb,
        }
    }
</script>

<style scoped>

</style>